import { EmployeeDetailDto } from '@personnel/application/dtos/EmployeeResponseDto';
import type { NotificationPreferencesConfigDto } from '@personnel/application/dtos';
import { EmployeeDetailViewModel } from '@personnel/presentation/types/EmployeeViewModel';
import { EmployeeFormData } from '@personnel/presentation/types';
import { buildNotificationPreferencesFormValue } from '@personnel/presentation/mappers/notificationPreferencesMapper';

export const employeeDetailDtoToViewModel = (dto: EmployeeDetailDto): EmployeeDetailViewModel => {
  return {
    uuid: dto.uuid,
    email: dto.email,
    fullName: dto.fullName,
    firstName: dto.firstName,
    lastName: dto.lastName,
    phoneNumber: dto.phoneNumber ?? null,
    hasSetEmailAndPassword: dto.hasSetEmailAndPassword,
    profileId: dto.profileId ?? '',
    posPin: dto.posPin ?? null,
    isActive: dto.isActive,
    roleUuid: dto.roleUuid ?? '',
    roleName: dto.roleName ?? null,
    assignedStores: (dto.assignedStores ?? []).map((s) => ({ uuid: s.uuid, name: s.name })),
    allStoresAssigned: !!dto.allStoresAssigned,
    verificationStatus: dto.verificationStatus,
    verificationRequirements: dto.verificationRequirements,
    notificationPreferences: dto.notificationPreferences ?? [],
  };
};

/**
 * The form defaults of an existing user.
 *
 * The configuration comes in as an argument because it decides which notification rows exist: the
 * record only says which of them are on.
 */
export const viewModelToEmployeeFormDefaults = (
  vm: EmployeeDetailViewModel,
  notificationConfig: NotificationPreferencesConfigDto,
): EmployeeFormData => {
  return {
    scope: 'general',
    roleUuid: vm.roleUuid || '',
    profileId: vm.profileId || '',
    firstName: vm.firstName || '',
    lastName: vm.lastName || '',
    email: vm.email || '',
    phoneNumber: vm.phoneNumber ?? '',
    posPin: vm.posPin ?? '',
    isActive: vm.isActive ?? true,
    assignedStores: vm.assignedStores ?? [],
    allStoresAssigned: vm.allStoresAssigned ?? false,
    notificationPreferences: buildNotificationPreferencesFormValue(notificationConfig, vm.notificationPreferences),
    _credentialsEnabled: false, // Will be calculated based on role permissions
    _pinEnabled: false, // Will be calculated based on role permissions
    _verificationStatus: vm.verificationStatus,
    _verificationRequirements: vm.verificationRequirements,
    _initialEmail: vm.email || '',
  };
};
